export default "__VITE_ASSET__CW6VB0NR__"